"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var events_1 = require('events');
var Object3D_1 = require('./Object3D');
var physics_1 = require('@voxeline/physics');
var CommandControl_1 = require('./controls/CommandControl');
var types_1 = require('./types');
var v = vec3.create();
var v0 = vec3.create();
var v1 = vec3.create();
var _aabb = new physics_1.AABB(v0, v1);
(function (UpdateAABB) {
    UpdateAABB[UpdateAABB["NONE"] = 0] = "NONE";
    UpdateAABB[UpdateAABB["TRANSLATE"] = 1] = "TRANSLATE";
    UpdateAABB[UpdateAABB["ROTATE"] = 2] = "ROTATE";
})(exports.UpdateAABB || (exports.UpdateAABB = {}));
var UpdateAABB = exports.UpdateAABB;
var GameObject = (function (_super) {
    __extends(GameObject, _super);
    function GameObject(game, id, model, options) {
        var vao = model.vao, shape = model.shape, shaderType = model.shaderType;
        _super.call(this, vao, shaderType, shape);
        this.game = game;
        this.model = model;
        this.id = id;
        this.foundObjects = new Set();
        this.emitter = new events_1.EventEmitter();
        var mass = typeof options.mass === 'number' ? options.mass : 1;
        var gravityMultiplier = typeof options.gravityMultiplier === 'number' ? options.gravityMultiplier : 1;
        vec3.multiply(v0, this.model.shape, this.scale);
        this.physics = new physics_1.RigidBody(this.position, v0, mass, 1, 0, gravityMultiplier, {
            onMove: this.handleMove.bind(this),
        });
        this.position = this.physics.aabb.center;
        this.physics.friction = 50;
        this.commandControl = new CommandControl_1.default(game, this);
    }
    GameObject.prototype.handleMove = function () {
        this.modelMatrixNeedsUpdate = true;
    };
    GameObject.prototype.setPosition = function (x, y, z) {
        this.physics.aabb.setCenter(x, y, z);
        return this;
    };
    GameObject.prototype.copyPosition = function (p) {
        this.physics.aabb.copyCenter(p);
        return this;
    };
    GameObject.prototype.addPosition = function (p) {
        this.physics.aabb.translate(p);
        return this;
    };
    GameObject.prototype.translateOnAxis = function (axis, distance) {
        vec3.copy(v0, axis);
        vec3.transformQuat(v0, v0, this.quaternion);
        vec3.scale(v0, v0, distance);
        this.physics.aabb.translate(v0);
        return this;
    };
    ;
    GameObject.prototype.setScale = function (x, y, z) {
        vec3.set(this.scale, x, y, z);
        vec3.multiply(v0, this.model.shape, this.scale);
        this.physics.aabb.copySize(v0);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    GameObject.prototype.onTick = function (dt) { };
    GameObject.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return (_a = this.emitter).emit.apply(_a, [event].concat(args));
        var _a;
    };
    GameObject.prototype.on = function (event, listener) {
        this.emitter.on(event, listener);
        return this;
    };
    GameObject.prototype.removeListener = function (event, listener) {
        this.emitter.removeListener(event, listener);
        return this;
    };
    GameObject.prototype.isListening = function (event, listener) {
        var listeners = this.emitter.listeners(event);
        return listeners.indexOf(listener) !== -1;
    };
    GameObject.prototype.onAppear = function (object) {
        this.emitter.emit('appear', object);
    };
    GameObject.prototype.onDisappear = function (object) {
    };
    GameObject.prototype.onObjectFound = function (object) {
        if (!this.foundObjects.has(object)) {
            this.foundObjects.add(object);
            this.onAppear(object);
        }
    };
    GameObject.prototype.onObjectNotFound = function (object) {
        if (this.foundObjects.has(object)) {
            this.foundObjects.delete(object);
            this.onDisappear(object);
        }
    };
    GameObject.prototype.update = function (dt, objects) {
        var sight = 50 * 50;
        for (var _i = 0, objects_1 = objects; _i < objects_1.length; _i++) {
            var object = objects_1[_i];
            if (object === this)
                continue;
            vec3.sub(v, this.position, object.position);
            if (vec3.squaredLength(v) <= sight) {
                this.onObjectFound(object);
            }
            else {
                this.onObjectNotFound(object);
            }
        }
        this.commandControl.update(dt);
        this.onTick(dt);
    };
    GameObject.prototype.getNearestObject = function (filter) {
        var ret = null;
        var minDistance = Infinity;
        var it = this.foundObjects.values();
        while (true) {
            var item = it.next();
            if (item.done)
                break;
            var object = item.value;
            if (!filter(object))
                continue;
            var dist = vec3.squaredDistance(this.position, object.position);
            if (dist < minDistance) {
                minDistance = dist;
                ret = object;
            }
        }
        return ret;
    };
    GameObject.prototype.move = function (path) {
        return this.commandControl.move(path);
    };
    GameObject.prototype.jump = function () {
        return this.commandControl.jump();
    };
    GameObject.prototype.stop = function (impulse) {
        if (impulse === void 0) { impulse = true; }
        this.commandControl.stop();
        if (impulse) {
            vec3.negate(v0, this.physics.velocity);
            this.physics.applyImpulse(v0);
        }
        return Promise.resolve();
    };
    GameObject.prototype.holdItem = function (item) {
        if (this.item)
            this.throwItem();
        this.item = item;
        this.itemObject = new Object3D_1.default(this.item.vao, types_1.ShaderType.PLAIN, this.item.size);
        this.itemObject.setScale(1.5, 1.5, 1.5);
        this.itemObject.setPosition(-this.size[0] / 2, this.size[1] / 4, this.size[2] + this.item.size[2] / 2);
        this.add(this.itemObject);
    };
    GameObject.prototype.throwItem = function () {
        if (this.item) {
            this.remove(this.itemObject);
            this.item = null;
            this.itemObject = null;
        }
    };
    GameObject.prototype.addSprite = function (vao) {
        var sprite = new Object3D_1.default(vao, types_1.ShaderType.SPRITE);
        sprite.translateY(18);
        this.add(sprite);
    };
    return GameObject;
}(Object3D_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GameObject;
//# sourceMappingURL=GameObject.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/GameObject.js
 ** module id = 908
 ** module chunks = 0
 **/